<template>
  <div class="experience-project">
    <div class="date"></div>
    <div class="timeline no-bullet" />
    <div class="data">
      <div class="section project">
        <span class="subtitle">projet {{ item.order ? item.order + 1 : '' }} : </span>
        <span v-html="item.content.title" />
        <div
          v-if="item.content.missions && item.content.missions"
          class="section missions"
          :class="{ selected: isSelected && currentSection === 'missions' }"
          @click="onClicked('missions')"
        >
          <div class="subtitle">Missions</div>
          <div class="items" v-html="item.content.missions"></div>
        </div>
        <div
          v-if="item.content.technos"
          class="section technos"
          :class="{ selected: isSelected && currentSection === 'technos' }"
          @click="onClicked('technos')"
        >
          <span class="subtitle">{{ $t(`resume.sections.${resumeLanguage}.common-technical-environment`) }}</span>
          {{ item.content.technos }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExperienceComponent',
  props: {
    item: {
      type: Object,
      required: true,
    },
    onClicked: {
      type: Function,
      required: true,
    },
    currentSection: {
      type: String,
      default: '',
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
    resumeLanguage: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.section,
.date {
  &:hover,
  &.selected {
    background-color: #fff9ef;
    cursor: pointer;
    border-radius: 12px;
  }
}
</style>
